import OrchestratorAPI from './common';

import { Job } from '../models/orchestrator/job';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/queue';

  async getSpecificJob(jobId: number): Promise<Job> {
    const url = this.constructPath(`/jobs/${jobId}`);
    const { job } = await this.common.getJSON(url);
    return job;
  }
}
